import React from "react";
import "./CheckOut.css";
import { Reserveseat } from "./Reserveseat";
import VidioCarousel from "./VidioCarousel";
import RobopackMontage from "../assets/videos/Sayantan-biswas.mp4";
import MonialIcn from "../assets/images/monial-icn.png";

const videos = [RobopackMontage];

export const CheckOut = () => {
  return (
   <div className="vidio-carousel-section">
    <div className="CheckOut_container">
      <div className="check-out-section">
        <div className="still-left-bar">
         <div className="monial-text"><span><img src={MonialIcn} alt="monial-icn" />Testimonial</span></div> 
         <div className="still-title">Still Don’t<br/> Trust us ?</div>
         <p className="title-ptag">Also there are few you must listen too</p> 
         {/* <div className="watch-now-btn"><a href="#">Watch Now</a></div>          */}
        </div>
        <div class="check-out-left">
          <div className="listen-vidio-left">
           <VidioCarousel />
          </div>
        </div>
      </div>
    </div>
    </div> 
  );
};
